import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import ImageWithBasePath from "../imageWithBasePath";
import "../../../style/icon/tabler-icons/webfont/tabler-icons.css";
import { setExpandMenu } from "../../data/redux/sidebarSlice";
import { useDispatch } from "react-redux";
import {
  resetAllMode,
  setDataLayout,
} from "../../data/redux/themeSettingSlice";
import usePreviousRoute from "./usePreviousRoute";
import { SidebarData } from "../../data/json/sidebarMenu";
import { translateLabel } from "../../i18n";
import { filterMenu } from "../../hooks/commonFunctions";
import { isSupportViewer } from "../../../utils/permissionUtils";
import { getApplicationModulesAPI } from "../../data/redux/applicationModulesSlice";
import { useSelector } from "react-redux";
import { all_routes } from "../../../feature-module/router/all_routes";
import { getStaffQuarterPermissions, getStaffQuarterAdminPermissions, getStaffQuarterCurrentRegistration } from "../../data/redux/staffQuarterSlice";
import { getNotificationsCountByType } from "../../data/redux/notificationsSlice";

const Sidebar = () => {
  const Location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const user: any = localStorage.getItem("user");
  const { data: applicationModulesResponse } = useSelector((state: any) => state.applicationModulesState || {});
  const applicationModules = applicationModulesResponse?.data || [];
  const staffQuarterState = useSelector((state: any) => state.staffQuarterState);
  const notificationsState = useSelector((state: any) => state.notificationsState);
  const unreadNotificationsCount = notificationsState?.countByType?.unread || notificationsState?.countByType?.data?.unread || 0;


  useEffect(() => {
    dispatch(getNotificationsCountByType({ action_group: "MY_NOTIFICATION" }));
  }, [dispatch]);
  const { permissions: sqPermissions, adminPermissions } = staffQuarterState || {};
  const currentRegistration = staffQuarterState?.currentRegistration?.data || null;
  const isCurrentRegistrationLoaded = !!staffQuarterState?.isCurrentRegistrationLoaded;

  const isRegistered = !!(currentRegistration && Object.keys(currentRegistration).length > 0 && (currentRegistration.id || currentRegistration.referenceNumber || currentRegistration.locationPreference1Id));

  let allowedPermissions: any = [];


  if (localStorage.getItem('allowed_permissions') != undefined && localStorage.getItem('allowed_permissions') != 'undefined') {
    allowedPermissions = JSON.parse(localStorage.getItem('allowed_permissions') || '[]');
  }




  const userJson = user && user != 'undefined' ? JSON.parse(user) : {};
  let userType: any = userJson?.user_type || userJson?.role;
  const originalUserType = userType; // preserve before any remapping
  if (userType == 'SUBADMIN' || isSupportViewer(userType)) {
    userType = 'ADMIN';
  }

  const routes = all_routes;
  const dashboardLink = (originalUserType === "ADMIN" || originalUserType === "SUBADMIN" || isSupportViewer(originalUserType)) ? routes.adminDashboard : routes.employeeDashboard;

  // Fallback to ADMIN if userType is not found or invalid
  if (!userType || !SidebarData[userType]) {
    console.warn('User type not found or invalid, defaulting to ADMIN. userType:', userType);
    userType = 'ADMIN';
  }

  let SidebarDataListArray: any = SidebarData[userType] || SidebarData['ADMIN'] || [];
  let dynamicSidebarData = JSON.parse(JSON.stringify(SidebarDataListArray));

  let modulesArray = Array.isArray(applicationModules)
    ? applicationModules
    : (Array.isArray(applicationModules?.data) ? applicationModules.data : []);

  if (userType === 'EMPLOYEE' && modulesArray.length > 0) {
    // Build a set of active slugs
    const activeSlugs = new Set(
      modulesArray
        .filter((mod: any) => mod.status === true)
        .map((mod: any) => mod.slug)
    );

    const filterBySlug = (items: any[]) => {
      return items
        .filter((item) => {
          if (item.slug) {
            return activeSlugs.has(item.slug);
          }
          return true;
        })
        .map((item) => {
          if (item.submenuItems && item.submenuItems.length > 0) {
            item.submenuItems = filterBySlug(item.submenuItems);
          }
          return item;
        });
    };

    dynamicSidebarData = dynamicSidebarData.map((mainItem: any) => {
      if (mainItem.submenuItems) {
        mainItem.submenuItems = filterBySlug(mainItem.submenuItems);
      }
      return mainItem;
    });
  }
  // Filter based on Staff Quarter permissions
  const filterMutualExchangeMenu = (items: any[]): any[] => items
    .filter(item => item.link !== routes.staffQuarter.management.mutualExchange ||
      (adminPermissions?.roles || []).includes("HR_ADMIN"))
    .map(item => ({ ...item, ...(item.submenuItems ? { submenuItems: filterMutualExchangeMenu(item.submenuItems) } : {}) }));
  dynamicSidebarData = filterMutualExchangeMenu(dynamicSidebarData);

  if (userType === 'EMPLOYEE') {
    const roles = adminPermissions?.roles || [];
    const sqPermissionsList = Array.isArray(adminPermissions?.permissions)
      ? adminPermissions.permissions
      : (Array.isArray(sqPermissions) ? sqPermissions : []);

    const getPermissionForModule = (moduleName: string) => {
      if (!Array.isArray(sqPermissionsList) || sqPermissionsList.length === 0) return true;
      const permsForModule = sqPermissionsList.filter((p: any) => p.module === moduleName && roles.includes(p.role));
      if (permsForModule.length > 0) {
        return permsForModule.some((p: any) => p.canView === true);
      }
      return true;
    };

    const filterBySQPermissions = (items: any[]): any[] => {
      return items
        .filter(item => {
          if (item.label === "Staff Quarter Management") {
            // "if your is not === employee then show this staff quarter management"
            // So if user roles only have "EMPLOYEE", hide "Staff Quarter Management"
            if (roles.length > 0 && !roles.some((r: string) => r !== "EMPLOYEE")) {
              return false;
            }
            // If roles are not loaded yet, default to false (hide)
            if (roles.length === 0) {
              return false;
            }
          }
          if (item.label === "Inbox") {
            // "and alos if user have approver in role then show inbox otherwise not"
            const hasApprover = roles.some((r: string) => r.toUpperCase().includes("APPROVER"));
            return hasApprover;
          }
          if (item.label === "Inventory") {
            // "if user have role of HR_ADMIN then show inventroy module otherwise not"
            return roles.includes("HR_ADMIN");
          }
          if (item.label === "Approval Settings" || item.label === "Staff Quarter Approval" || item.label === "Approval Configuration" || item.label === "Staff Quarter") {
            return roles.includes("HR_ADMIN") || roles.some((r: string) => r.toLowerCase().includes("hr") && r.toLowerCase().includes("admin"));
          }
          if (item.label === "Letter Customization" || item.label === "Letter Templates") {
            return roles.includes("HR_ADMIN") || roles.some((r: string) => r.toLowerCase().includes("hr") && r.toLowerCase().includes("admin"));
          }
          if (item.label === "Priority List" && (item.link === routes.staffQuarterAdmin?.priorityList || item.link === routes.staffQuarter?.management?.priorityList)) {
            return getPermissionForModule("priority-list");
          }
          if ((item.label === "My Priority" || item.label === "Priority List") && item.link === routes.staffQuarter.priorityList) {
            return true;
          }
          if (item.label === "Allotment") {
            const hasAllotmentPerm = Array.isArray(sqPermissionsList) && sqPermissionsList.some((p: any) => p.module === "allotment" && roles.includes(p.role) && p.canView === true);
            const hasAllotmentModule = Array.isArray(adminPermissions?.modules) && adminPermissions.modules.includes("allotment");
            return roles.includes("HR_ADMIN") || hasAllotmentPerm || hasAllotmentModule;
          }
          if (item.label === "Change Current Approver") {
            return roles.includes("HR_ADMIN");
          }
          if (item.label === "Willingness Invited" || item.label === "Willingness Invited Report" || item.label === "Willingness") {
            return roles.includes("HR_ADMIN");
          }
          if (item.label === "Reports") {
            return getPermissionForModule("export");
          }
          return true;
        })
        .map(item => {
          if (item.submenuItems && item.submenuItems.length > 0) {
            return {
              ...item,
              submenuItems: filterBySQPermissions(item.submenuItems)
            };
          }
          return item;
        });
    };

    dynamicSidebarData = dynamicSidebarData.map((mainItem: any) => {
      if (mainItem.submenuItems) {
        return {
          ...mainItem,
          submenuItems: filterBySQPermissions(mainItem.submenuItems)
        };
      }
      return mainItem;
    });
  }

  let SidebarDataList = dynamicSidebarData || [];

  if ((userType === 'EMPLOYEE' || userType === 'ADMIN' || userType === 'SUBADMIN' || isSupportViewer(originalUserType)) && dynamicSidebarData && dynamicSidebarData.length > 0) {
    SidebarDataList = filterMenu(dynamicSidebarData, allowedPermissions, originalUserType) || [];
  }

  // Ensure SidebarDataList is always an array
  if (!Array.isArray(SidebarDataList)) {
    console.warn('SidebarDataList is not an array, defaulting to empty array');
    SidebarDataList = [];
  }

  // Dynamic resizable sidebar width state and logic
  const [sidebarWidth, setSidebarWidth] = useState(() => {
    const saved = localStorage.getItem("sidebarWidth");
    return saved ? parseInt(saved, 10) : 252;
  });

  const isResizing = useRef(false);

  useEffect(() => {
    document.documentElement.style.setProperty("--sidebar-width", `${sidebarWidth}px`);
  }, [sidebarWidth]);

  const handleMouseMove = (mouseMoveEvent: MouseEvent) => {
    if (!isResizing.current) return;
    const newWidth = Math.max(180, Math.min(480, mouseMoveEvent.clientX));
    setSidebarWidth(newWidth);
    localStorage.setItem("sidebarWidth", String(newWidth));
  };

  const stopResizing = () => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", stopResizing);
    document.body.classList.remove("is-resizing");
    document.body.style.cursor = "";
    document.body.style.userSelect = "";
  };

  const startResizing = (mouseDownEvent: React.MouseEvent) => {
    mouseDownEvent.preventDefault();
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", stopResizing);
    document.body.classList.add("is-resizing");
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };

  useEffect(() => {
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", stopResizing);
    };
  }, []);
  const [subOpen, setSubopen] = useState<any>("Dashboard");
  const [subsidebar, setSubsidebar] = useState("");
  const [level4Open, setLevel4Open] = useState("");
  const lastPathnameRef = useRef("");

  const toggleLevel4 = (subitem: any) => {
    if (subitem === level4Open) {
      setLevel4Open("");
    } else {
      setLevel4Open(subitem);
    }
  };

  const toggleSidebar = (title: any) => {
    localStorage.setItem("menuOpened", title);
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const handleLayoutChange = (layout: string) => {
    dispatch(setDataLayout(layout));
  };

  const handleClick = (label: any, themeSetting: any, layout: any) => {
    toggleSidebar(label);
    if (themeSetting) {
      handleLayoutChange(layout);
    }
  };

  const getLayoutClass = (label: any) => {
    switch (label) {
      case "Default":
        return "default_layout";
      case "Mini":
        return "mini_layout";
      case "Box":
        return "boxed_layout";
      case "Dark":
        return "dark_data_theme";
      case "RTL":
        return "rtl";
      default:
        return "";
    }
  };
  const location = useLocation();
  const previousLocation = usePreviousRoute();

  useEffect(() => {
    const isOnStaffQuartersPage = location.pathname.includes('/staff-quarters');
    if (userType === 'EMPLOYEE' && !isCurrentRegistrationLoaded && isOnStaffQuartersPage) {
      dispatch(getStaffQuarterCurrentRegistration({}));
    }
  }, [dispatch, userType, isCurrentRegistrationLoaded, location.pathname]);

  useEffect(() => {
    const layoutPages = [
      "/layout-dark",
      "/layout-rtl",
      "/layout-mini",
      "/layout-box",
      "/layout-default",
    ];

    const isCurrentLayoutPage = layoutPages.some((path) =>
      location.pathname.includes(path)
    );
    const isPreviousLayoutPage =
      previousLocation &&
      layoutPages.some((path) => previousLocation.pathname.includes(path));


  }, [location, previousLocation, dispatch]);

  useEffect(() => {
    const currentMenu = localStorage.getItem("menuOpened") || 'Dashboard'
    setSubopen(currentMenu);
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll(".submenu");
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll("li");
      submenu.classList.remove("active");
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains("active")) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add("active");
          return;
        }
      });
    });
  }, [Location.pathname]);

  useEffect(() => {
    if (Location.pathname === lastPathnameRef.current) return;
    lastPathnameRef.current = Location.pathname;

    if (!SidebarDataList || SidebarDataList.length === 0) return;

    let foundSubOpen = "";
    let foundSubsidebar = "";
    let foundLevel4Open = "";

    const currentPath = Location.pathname;

    for (const mainLabel of SidebarDataList) {
      if (!mainLabel.submenuItems) continue;
      for (const title of mainLabel.submenuItems) {
        if (title.link === currentPath) {
          foundSubOpen = title.label;
        }

        if (title.submenuItems) {
          for (const item of title.submenuItems) {
            if (item.link === currentPath) {
              foundSubOpen = title.label;
              foundSubsidebar = item.label;
            }

            if (item.submenuItems) {
              for (const items of item.submenuItems) {
                if (items.link === currentPath) {
                  foundSubOpen = title.label;
                  foundSubsidebar = item.label;
                  foundLevel4Open = items.label;
                }

                if (items.submenuItems) {
                  for (const level4Item of items.submenuItems) {
                    if (level4Item.link === currentPath) {
                      foundSubOpen = title.label;
                      foundSubsidebar = item.label;
                      foundLevel4Open = items.label;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    if (foundSubOpen) {
      setSubopen(foundSubOpen);
      localStorage.setItem("menuOpened", foundSubOpen);
    }
    if (foundSubsidebar) {
      setSubsidebar(foundSubsidebar);
    }
    if (foundLevel4Open) {
      setLevel4Open(foundLevel4Open);
    }
  }, [Location.pathname, SidebarDataList]);

  const onMouseEnter = () => {
    dispatch(setExpandMenu(true));
  };
  const onMouseLeave = () => {
    dispatch(setExpandMenu(false));
  };
  return (
    <>
      <style>{`
        :root {
          --sidebar-width: 252px;
        }
        @media (min-width: 992px) {
          /* When NOT mini-sidebar OR when mini-sidebar is expanded (hovered) */
          div:not(.mini-sidebar) > .main-wrapper .sidebar,
          div.mini-sidebar.expand-menu > .main-wrapper .sidebar {
            width: var(--sidebar-width) !important;
          }
          div:not(.mini-sidebar) > .main-wrapper .sidebar-logo,
          div.mini-sidebar.expand-menu > .main-wrapper .sidebar-logo {
            width: var(--sidebar-width) !important;
          }
          div:not(.mini-sidebar) > .main-wrapper .page-wrapper,
          div.mini-sidebar.expand-menu > .main-wrapper .page-wrapper {
            margin-left: var(--sidebar-width) !important;
          }
          div:not(.mini-sidebar) > .main-wrapper .header,
          div.mini-sidebar.expand-menu > .main-wrapper .header {
            left: var(--sidebar-width) !important;
          }

          /* Minimized sidebar (not expanded on hover) */
          div.mini-sidebar:not(.expand-menu) > .main-wrapper .sidebar {
            width: 80px !important;
          }
          div.mini-sidebar:not(.expand-menu) > .main-wrapper .sidebar-logo {
            width: 80px !important;
          }
          div.mini-sidebar:not(.expand-menu) > .main-wrapper .page-wrapper {
            margin-left: 80px !important;
          }
          div.mini-sidebar:not(.expand-menu) > .main-wrapper .header {
            left: 80px !important;
          }
        }
        .is-resizing .sidebar,
        .is-resizing .page-wrapper,
        .is-resizing .header {
          transition: none !important;
        }
        .sidebar-resizer {
          position: absolute;
          top: 0;
          bottom: 0;
          right: -2px;
          width: 5px;
          cursor: col-resize;
          z-index: 10000;
          transition: background-color 0.15s ease;
        }
        .sidebar-resizer:hover,
        .is-resizing .sidebar-resizer {
          background-color: rgba(228, 31, 7, 0.45);
          box-shadow: 0 0 4px rgba(228, 31, 7, 0.45);
        }

        /* Clean styling for menu links and icons when minimized */
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a {
          justify-content: center !important;
          padding: 8px 0 !important;
          background: transparent !important;
        }
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a.active {
          background: transparent !important;
        }
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a.subdrop {
          background: transparent !important;
        }
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a i {
          margin: 0 !important;
        }
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a:hover i {
          background: #FFEEEC !important;
          color: #E41F07 !important;
        }
        div.mini-sidebar:not(.expand-menu) .sidebar .sidebar-menu > ul > li ul li a.active:hover i {
          background: #E41F07 !important;
          color: #FFF !important;
        }
        .sidebar-menu li a.disabled,
        .sidebar-menu li a.disabled:hover {
          opacity: 0.55 !important;
          cursor: not-allowed !important;
          background: transparent !important;
          color: #94a3b8 !important;
        }
      `}</style>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={{
          // paddingLeft:"3rem"
          // width:280
        }}
      >
        <div
          className="sidebar-resizer"
          onMouseDown={startResizing}
        />
        <div
          className="sidebar-logo"
          style={{
            backgroundColor: "white",
            zIndex: 50,
            marginBottom: 50,
          }}
        >
          <Link
            to={dashboardLink}
            className="logo logo-normal"
            style={{
              backgroundColor: "white",
              zIndex: 50,
            }}
          >
            <ImageWithBasePath src="assets/img/logo.svg" alt="Logo" />
          </Link>
          <Link
            to={dashboardLink}
            className="logo-small"
            style={{
              backgroundColor: "white",
              zIndex: 50,
            }}
          >
            <ImageWithBasePath src="assets/img/logo-small.svg" alt="Logo" />
          </Link>
        </div>

        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              {!SidebarDataList || SidebarDataList.length === 0 ? (
                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                  <p>No menu items available</p>
                  <small>User Type: {userType || 'Unknown'}</small>
                </div>
              ) : (
                <ul>
                  {SidebarDataList?.map((mainLabel: any, index: number) => (
                    <React.Fragment key={`main-${index}`}>
                      <li className="menu-title">
                        <span
                          className="text-danger "
                          style={{ fontSize: "13px" }}
                        >
                          {translateLabel(mainLabel?.tittle)}
                        </span>
                      </li>
                      <li>
                        <ul>
                          {mainLabel?.submenuItems?.map(
                            (title: any, i: number) => {
                              let link_array: any = [];
                              if ("submenuItems" in title) {
                                title.submenuItems?.forEach((link: any) => {
                                  link_array.push(link?.link);
                                  if (link?.submenu && "submenuItems" in link) {
                                    link.submenuItems?.forEach((item: any) => {
                                      link_array.push(item?.link);
                                    });
                                  }
                                });
                              }
                              title.links = link_array;

                              return (
                                <li className="submenu" key={`title-${i}`}>
                                  <Link
                                    to={title?.submenuItems?.length > 0 ? "#" : title?.link}
                                    onClick={() =>
                                      handleClick(
                                        title?.label,
                                        title?.themeSetting,
                                        getLayoutClass(title?.label)
                                      )
                                    }
                                    className={`${subOpen === title?.label ? "subdrop" : ""
                                      } ${title?.links?.includes(Location.pathname)
                                        ? "active"
                                        : ""
                                      } ${title?.submenuItems
                                        ?.map((link: any) => link?.link)
                                        .includes(Location.pathname) ||
                                        title?.link === Location.pathname
                                        ? "active"
                                        : ""
                                      }`}
                                  >
                                    <i className={`ti ti-${title.icon}`}></i>
                                    <span>{translateLabel(title?.label)}</span>
                                    {title?.label === "Notifications" && Number(unreadNotificationsCount) > 0 && (
                                      <span className="badge bg-danger text-white rounded-pill float-end ms-2" style={{ fontSize: "12px", padding: "2px 6px", color: "#fff" }}>
                                        {unreadNotificationsCount}
                                      </span>
                                    )}
                                    {title?.dot && (
                                      <span className="badge badge-danger fs-10 fw-medium text-white p-1">
                                        Hot
                                      </span>
                                    )}
                                    <span
                                      className={
                                        title?.submenuItems?.length > 0 ? "menu-arrow" : ""
                                      }
                                    />
                                  </Link>
                                  {title?.submenuItems?.length > 0 &&
                                    subOpen === title?.label && (
                                      <ul
                                        style={{
                                          display:
                                            subOpen === title?.label
                                              ? "block"
                                              : "none",
                                          maxHeight: "400px",
                                          overflowY: "auto",
                                          overflowX: "hidden",
                                          scrollbarWidth: "thin",
                                          msOverflowStyle: "scrollbar",
                                        }}
                                        className="scrollable-submenu"
                                      >
                                        {title?.submenuItems?.map(
                                          (item: any, j: any) => {
                                            return (
                                              <li
                                                className={
                                                  item?.submenuItems
                                                    ? "submenu submenu-two"
                                                    : ""
                                                }
                                                key={`item-${j}`}
                                              >
                                                <Link
                                                  to={
                                                    item?.disabled ? "#" : item?.submenuItems?.length > 0 ? "#" : item?.link
                                                  }
                                                  style={item?.disabled ? { opacity: 0.55, cursor: "not-allowed" } : undefined}
                                                  className={`${item?.submenuItems
                                                    ?.map(
                                                      (link: any) => link?.link
                                                    )
                                                    .includes(
                                                      Location.pathname
                                                    ) ||
                                                    item?.link === Location.pathname
                                                    ? "active"
                                                    : ""
                                                    } ${subsidebar === item?.label
                                                      ? "subdrop"
                                                      : ""
                                                    } ${item?.disabled ? "disabled text-muted" : ""}`}
                                                  onClick={(e) => {
                                                    if (item?.disabled) {
                                                      e.preventDefault();
                                                      e.stopPropagation();
                                                      return;
                                                    }
                                                    if (item?.submenuItems?.length > 0) {
                                                      e.preventDefault();
                                                    }
                                                    toggleSubsidebar(item?.label);
                                                  }}
                                                >
                                                  <span>{translateLabel(item?.label)}</span> {item?.label === "Inventory" ? `[DEBUG: ${item?.submenuItems?.length ? "HAS_SUBMENU" : "EMPTY"}]` : ""}
                                                  {item?.disabled && (
                                                    <span
                                                      className="badge bg-light text-muted border ms-auto fs-10 py-0.5 px-1.5"
                                                      style={{ fontSize: "10px", lineHeight: "1" }}
                                                    >
                                                      Disabled
                                                    </span>
                                                  )}
                                                  <span
                                                    className={
                                                      item?.submenuItems?.length > 0
                                                        ? "menu-arrow"
                                                        : ""
                                                    }
                                                  />
                                                </Link>
                                                {item?.submenuItems ? (
                                                  <ul
                                                    style={{
                                                      display: subsidebar === item?.label ? "block" : "none",
                                                    }}
                                                  >
                                                    {item?.submenuItems?.map(
                                                      (items: any, k: any) => (
                                                        <li
                                                          key={`submenu-item-${k}`}
                                                          className={items?.submenuItems ? "submenu submenu-two" : ""}
                                                        >
                                                          <Link
                                                            to={
                                                              items?.submenuItems?.length > 0
                                                                ? "#"
                                                                : items?.link
                                                            }
                                                            className={`${items?.link === Location.pathname ? "active" : ""} ${level4Open === items?.label ? "subdrop" : ""}`}
                                                            onClick={(e) => {
                                                              if (items?.submenuItems?.length > 0) {
                                                                e.preventDefault();
                                                                // Open the submenu if it's not already open
                                                                if (level4Open !== items?.label) {
                                                                  toggleLevel4(items?.label);
                                                                  // Auto-navigate to first child if it exists
                                                                  if (items.submenuItems[0]?.link) {
                                                                    navigate(items.submenuItems[0].link);
                                                                  }
                                                                } else {
                                                                  // Just close it if it's already open
                                                                  toggleLevel4(items?.label);
                                                                }
                                                              }
                                                            }}
                                                          >
                                                            {translateLabel(items?.label)}
                                                            {items?.submenuItems?.length > 0 && (
                                                              <span
                                                                style={{
                                                                  position: 'absolute',
                                                                  right: '30px',
                                                                  top: '50%',
                                                                  marginTop: '-4px',
                                                                  width: '7px',
                                                                  height: '7px',
                                                                  borderTop: '2px solid',
                                                                  borderRight: '2px solid',
                                                                  borderColor: level4Open === items?.label ? '#E41F07' : '#74788d',
                                                                  transform: level4Open === items?.label ? 'rotate(-45deg)' : 'rotate(0deg)',
                                                                  transition: 'transform 0.2s ease',
                                                                  display: 'inline-block'
                                                                }}
                                                              />
                                                            )}
                                                          </Link>
                                                          {items?.submenuItems && (
                                                            <ul
                                                              style={{
                                                                display: level4Open === items?.label ? "block" : "none",
                                                                paddingLeft: '25px'
                                                              }}
                                                            >
                                                              {items?.submenuItems?.map((level4Item: any, l: number) => (
                                                                <li key={`level4-item-${l}`}>
                                                                  <Link
                                                                    to={level4Item?.link}
                                                                    className={level4Item?.link === Location.pathname ? "active" : ""}
                                                                  >
                                                                    {translateLabel(level4Item?.label)}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          )}
                                                        </li>
                                                      )
                                                    )}
                                                  </ul>
                                                ) : null}
                                              </li>
                                            );
                                          }
                                        )}
                                      </ul>
                                    )}
                                </li>
                              );
                            }
                          )}
                        </ul>
                      </li>
                    </React.Fragment>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
